import { Package } from "lucide-react";
import { getMaterials } from "@/lib/api";

const materialsProvider = {
  id: "materiales",
  label: "Materiales",
  icon: Package,
  iconBg: "bg-orange-50",
  iconColor: "text-orange-600",
  fields: ["name", "description", "category_name"],
  load: async (districtId) => {
    const items = await getMaterials({ district_id: districtId });
    return items.map((m) => ({
      ...m,
      category_name: m.material_categories?.name || "",
    }));
  },
  buildItem: (m) => ({
    id: m.id,
    title: m.name,
    subtitle: m.category_name || "Material",
    route: `/materials/${m.id}`,
    recent: null,
  }),
};

export default materialsProvider;
